module.exports = __webpack_public_path__ + "dd80b4afb9041a2d2cbf66598e8da973.png";